import { useEffect } from 'react';
import { $getRoot } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { populateEditorFromFormulaString } from '../../../../utils/formulas/formulas-lexical';
import { FormulaReferenceOption } from '../../../../utils/formulas/types';

interface InitialContentPluginProps {
  autoFocus?: boolean;
  formulaContent: string;
  initialEditorOptions: FormulaReferenceOption[];
}

export const InitialContentPlugin = ({
  autoFocus = false,
  formulaContent,
  initialEditorOptions
}: InitialContentPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    populateEditorFromFormulaString(editor, formulaContent, initialEditorOptions);

    if (autoFocus) {
      // Move the selection to the end of any existing formula content (or leave it at the
      // start of an empty editor) and focus the editor so the user can start typing right away.
      editor.update(() => {
        $getRoot().selectEnd();
      });
      editor.focus();
    }
  }, [autoFocus, editor, formulaContent, initialEditorOptions]);

  return null;
};
